/* ============================================================
   DM KONFIGURATOR — Nachtrag: Kauf abgesichert
   Diving Mask · Eigenentwicklung
   ------------------------------------------------------------
   Anlass: Bestellung #1977 vom 29.09.2026. Dort lag nur die
   Maske auf der None-Variante im Warenkorb (202 $), die
   Verglasungs-Position ueber 580 EUR fehlte. Der Kunde hatte
   sein Rezept als Foto hochgeladen.

   Ursache: Beim Upload-Weg braucht dmItemsKauf() zwei Aufrufe
   an /cart/add.js, weil Dateien nicht im JSON-Koerper reisen
   koennen. Im Original geht zuerst die Maske raus, danach die
   Verglasung mit der Datei. Scheitert der zweite Aufruf, liegt
   die Maske allein im Warenkorb - und der Fehlerzweig hat das
   nur in die Konsole geschrieben und still auf /cart geleitet.

   Dieser Nachtrag aendert zweierlei:

   1. Reihenfolge und Ruecknahme. Zuerst geht die Verglasung
      mitsamt Datei raus, danach der Rest. Scheitert der zweite
      Schritt, wird die bereits angelegte Zeile wieder entfernt.
      Es bleibt also entweder alles im Warenkorb oder nichts.
      Der Kunde sieht in jedem Fehlerfall einen sichtbaren Hinweis.

   2. Waechter im Warenkorb. Eine Position mit _gruppe, die
      allein steht und keine Werkstattzeile traegt, ist eine
      Maske ohne ihre Verglasung. Solange die im Warenkorb
      liegt, wird die Kasse gesperrt und der Kunde informiert.
      Das faengt auch Altfaelle und fremde Fehlerquellen ab.

   Additiv. dm-konfigurator.js bleibt unveraendert.
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Texte ----------------------------------------
     Eigene Tabelle statt locales: der Nachtrag soll ohne
     Sprachdatei-Aenderung in allen Maerkten lesbar sein.     */

  var TEXTE = {
    de: {
      kauf_fehler: 'Die Verglasung konnte nicht in den Warenkorb gelegt werden. Es wurde nichts hinzugefügt. Bitte versuchen Sie es noch einmal oder schreiben Sie uns an support@diving-mask.com.',
      datei_fehler: 'Die Rezeptdatei konnte nicht übertragen werden. Bitte versuchen Sie es mit einer kleineren Datei oder wählen Sie „Werte später nachreichen“.',
      wache_titel: 'In Ihrem Warenkorb fehlt die Verglasung',
      wache_text: 'Zu dieser Maske wurde eine Verglasung gewählt, sie ist aber nicht im Warenkorb gelandet. Bitte entfernen Sie die Maske und legen Sie sie über den Konfigurator neu an, oder schreiben Sie uns an support@diving-mask.com.',
      wache_knopf: 'Position entfernen'
    },
    en: {
      kauf_fehler: 'The prescription lenses could not be added to your cart. Nothing was added. Please try again or write to support@diving-mask.com.',
      datei_fehler: 'Your prescription file could not be uploaded. Please try a smaller file or choose “Send values later”.',
      wache_titel: 'The lenses are missing from your cart',
      wache_text: 'Prescription lenses were chosen for this mask, but they did not make it into your cart. Please remove the mask and add it again through the configurator, or write to support@diving-mask.com.',
      wache_knopf: 'Remove item'
    },
    fr: {
      kauf_fehler: 'Les verres correcteurs n’ont pas pu être ajoutés au panier. Rien n’a été ajouté. Merci de réessayer ou de nous écrire à support@diving-mask.com.',
      datei_fehler: 'Votre ordonnance n’a pas pu être transmise. Essayez un fichier plus petit ou choisissez « Envoyer les valeurs plus tard ».',
      wache_titel: 'Les verres manquent dans votre panier',
      wache_text: 'Des verres correcteurs ont été choisis pour ce masque, mais ils ne sont pas arrivés dans le panier. Merci de retirer le masque et de le reconfigurer, ou de nous écrire à support@diving-mask.com.',
      wache_knopf: 'Retirer l’article'
    },
    es: {
      kauf_fehler: 'No se han podido añadir las lentes graduadas a la cesta. No se ha añadido nada. Inténtalo de nuevo o escríbenos a support@diving-mask.com.',
      datei_fehler: 'No se ha podido subir tu receta. Prueba con un archivo más pequeño o elige «Enviar los valores más tarde».',
      wache_titel: 'Faltan las lentes en tu cesta',
      wache_text: 'Se han elegido lentes graduadas para esta máscara, pero no han llegado a la cesta. Retira la máscara y vuelve a configurarla, o escríbenos a support@diving-mask.com.',
      wache_knopf: 'Quitar artículo'
    }
  };

  function sprache() {
    var l = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
    return TEXTE[l] ? l : 'en';
  }

  function t(schluessel) {
    return TEXTE[sprache()][schluessel] || TEXTE.en[schluessel] || '';
  }

  /* ---------- Hilfen ---------------------------------------- */

  function wurzelPfad() {
    var sh = window.Shopify;
    if (sh && sh.routes && sh.routes.root) return sh.routes.root;
    return '/';
  }

  function zufallsToken() {
    var zufall = '';
    try {
      if (window.crypto && window.crypto.getRandomValues) {
        var arr = new Uint32Array(2);
        window.crypto.getRandomValues(arr);
        zufall = arr[0].toString(36) + arr[1].toString(36);
      }
    } catch (e) { /* unten der Ersatz */ }
    if (!zufall) {
      zufall = Math.random().toString(36).slice(2) +
               Math.random().toString(36).slice(2);
    }
    return 'Set-' + zufall.slice(-6).toUpperCase();
  }

  function pruefen(d) {
    if (d && d.status) {
      throw new Error(d.description || d.message || 'cart');
    }
    return d;
  }

  function jsonAn(pfad, koerper) {
    return fetch(pfad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(koerper)
    }).then(function (r) { return r.json(); }).then(pruefen);
  }

  /* Eine bereits angelegte Zeile wieder herausnehmen. Schlaegt
     auch das fehl, bleibt nur der Waechter unten als Netz.     */
  function zeileZuruecknehmen(schluessel) {
    if (!schluessel) return Promise.resolve(null);
    return jsonAn(wurzelPfad() + 'cart/change.js', { id: schluessel, quantity: 0 })
      .catch(function (e) {
        console.warn('[dm-kauf] Ruecknahme fehlgeschlagen:', e);
        return null;
      });
  }

  /* Der Schluessel der Zeile, die ein add.js-Aufruf angelegt hat.
     Ein einzelner Artikel kommt als Objekt zurueck, ein
     items-Array als { items: [...] }.                          */
  function ersterSchluessel(antwort) {
    if (!antwort) return null;
    if (antwort.key) return antwort.key;
    if (antwort.items && antwort.items.length) return antwort.items[0].key;
    return null;
  }

  /* ---------- Teil 1: Kauf ---------------------------------- */

  function kaufPatchen(Klasse) {
    var P = Klasse && Klasse.prototype;
    if (!P || P._dmKaufAbgesichert) return;
    if (typeof P.dmItemsKauf !== 'function') return;
    P._dmKaufAbgesichert = true;

    P._kaufFehlerZeigen = function (text) {
      try {
        if (this.el && this.el.hinweis) {
          this.el.hinweis.textContent = text;
          this.el.hinweis.hidden = false;
          this.el.hinweis.setAttribute('role', 'alert');
        }
        if (this.el && this.el.trigger) {
          this.el.trigger.classList.add('is-fehler');
          this.el.trigger.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      } catch (e) { /* Anzeige ist Beiwerk, der Abbruch zaehlt */ }
    };

    P.dmItemsKauf = function () {
      var self = this;
      if (!this.dmItemsBereit()) return Promise.resolve(false);

      var a = this.auswahl;

      var basis = this._basisVariante();
      var basisId = basis ? basis.id : null;
      if (!basisId) {
        var feld = this.form && this.form.querySelector('select[name="id"], input[name="id"]');
        if (feld && feld.value) basisId = Number(feld.value);
      }
      if (!basisId) return Promise.resolve(false);
      if (!this.glasImPreis && !a.art.varianteId) return Promise.resolve(false);

      var menge = 1;
      if (this.form && this.form.elements && this.form.elements.quantity) {
        menge = parseInt(this.form.elements.quantity.value, 10) || 1;
      }
      if (menge < 1) menge = 1;

      var gruppe = zufallsToken();
      var maskenTitel = (this.daten && this.daten.produkt && this.daten.produkt.titel) || '';

      var tp = this.t || {};
      var nMaske = tp.p_maske || 'Maske';

      var maskeProps = { '_gruppe': gruppe };
      maskeProps[tp.p_verglasung || 'Verglasung'] = a.art.titel;

      var glasProps = { '_gruppe': gruppe, '_zusatz': '1' };
      glasProps[nMaske] = maskenTitel;
      this._rezeptFelder().forEach(function (f) { glasProps[f[0]] = f[1]; });
      if (a.design) glasProps[tp.p_design || 'Glas-Design'] = a.design.titel;
      if (a.dicke) glasProps[tp.p_dicke || 'Glasdicke'] = a.dicke.titel;
      if (a.name) glasProps[tp.p_name || 'Trägername'] = a.name;
      glasProps['_Werkstatt'] = this._werkstattGlas();
      glasProps['_Werte'] = this._werkstattWerte();

      if (this.glasImPreis) {
        Object.keys(glasProps).forEach(function (k) {
          if (k === '_gruppe' || k === '_zusatz' || k === nMaske) return;
          maskeProps[k] = glasProps[k];
        });
      }

      function nebenProps() {
        var p = { '_gruppe': gruppe, '_zusatz': '1' };
        p[nMaske] = maskenTitel;
        return p;
      }

      var maskeItem = { id: Number(basisId), quantity: menge, properties: maskeProps };

      var dickeItem = null;
      if (a.dicke && a.dicke.varianteId) {
        dickeItem = { id: Number(a.dicke.varianteId), quantity: menge, properties: nebenProps() };
      }

      var glasItem = {
        id: Number(a.art.varianteId),
        quantity: menge,
        properties: glasProps
      };

      var extraItems = a.extras.filter(function (e) { return e.varianteId; })
        .map(function (e) {
          return { id: Number(e.varianteId), quantity: menge, properties: nebenProps() };
        });

      var datei = a.methode === 'upload' && this._dateiInput &&
        this._dateiInput.files && this._dateiInput.files[0]
        ? this._dateiInput.files[0]
        : null;

      var pfad = wurzelPfad() + 'cart/add.js';
      var lauf;

      if (!datei) {
        /* Ein einziger Aufruf. Entweder alles oder nichts - das
           war schon vorher sicher und bleibt so.                */
        var items = [maskeItem];
        if (!this.glasImPreis) items.push(glasItem);
        if (dickeItem) items.push(dickeItem);
        extraItems.forEach(function (it) { items.push(it); });
        lauf = jsonAn(pfad, { items: items });
      } else {
        /* Mit Datei sind zwei Aufrufe unvermeidlich. Neu ist die
           Reihenfolge: zuerst die Zeile mit der Datei, denn sie
           ist die teure und die fehleranfaellige. Erst wenn die
           steht, kommt der Rest. Scheitert der Rest, wird die
           erste Zeile wieder herausgenommen.                     */
        var traegerItem = this.glasImPreis ? maskeItem : glasItem;
        var traegerProps = this.glasImPreis ? maskeProps : glasProps;

        var rest = [];
        if (!this.glasImPreis) rest.push(maskeItem);
        if (dickeItem) rest.push(dickeItem);
        extraItems.forEach(function (it) { rest.push(it); });

        var fd = new FormData();
        fd.append('id', String(traegerItem.id));
        fd.append('quantity', String(menge));
        Object.keys(traegerProps).forEach(function (k) {
          fd.append('properties[' + k + ']', traegerProps[k]);
        });
        fd.append('properties[' + (tp.p_pass || 'Brillenpass') + ']', datei);

        lauf = fetch(pfad, { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(pruefen)
          .catch(function (e) {
            e.dmGrund = 'datei';
            throw e;
          })
          .then(function (antwort) {
            if (!rest.length) return antwort;
            var schluessel = ersterSchluessel(antwort);
            return jsonAn(pfad, { items: rest }).catch(function (e) {
              return zeileZuruecknehmen(schluessel).then(function () { throw e; });
            });
          });
      }

      return lauf.then(function () {
        if (self.el && self.el.hinweis) self.el.hinweis.hidden = true;
        document.dispatchEvent(new CustomEvent('cart:build'));
        self._warenkorbOeffnen();
        return true;
      }).catch(function (e) {
        console.warn('[dm-kauf] Kauf abgebrochen:', e);
        self._kaufFehlerZeigen(e && e.dmGrund === 'datei' ? t('datei_fehler') : t('kauf_fehler'));
        return false;
      });
    };
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('dm-konfigurator').then(function () {
      kaufPatchen(customElements.get('dm-konfigurator'));
    }).catch(function () { /* ohne Konfigurator bleibt nur der Waechter */ });
  }

  /* ---------- Teil 2: Waechter im Warenkorb ------------------
     Kaputt ist eine Gruppe genau dann, wenn eine Zeile mit
     _gruppe allein steht und keine Werkstattzeile traegt:

       zwei Zeilen         -> Maske + Verglasung, in Ordnung
       eine mit _Werkstatt -> Glaeser-Produkt, in Ordnung
       eine ohne           -> Maske ohne ihre Verglasung, kaputt
     ------------------------------------------------------------ */

  var WACHE_ID = 'dm-kauf-wache';
  var gesperrt = false;

  function kaputteZeilen(warenkorb) {
    var gruppen = {};
    (warenkorb.items || []).forEach(function (zeile) {
      var p = zeile.properties || {};
      var g = p._gruppe;
      if (!g) return;
      if (!gruppen[g]) gruppen[g] = [];
      gruppen[g].push(zeile);
    });

    var kaputt = [];
    Object.keys(gruppen).forEach(function (g) {
      var zeilen = gruppen[g];
      if (zeilen.length > 1) return;
      var p = zeilen[0].properties || {};
      if (p._Werkstatt) return;
      kaputt.push(zeilen[0]);
    });
    return kaputt;
  }

  function bannerZeigen(zeile) {
    if (document.getElementById(WACHE_ID)) return;

    var kasten = document.createElement('div');
    kasten.id = WACHE_ID;
    kasten.setAttribute('role', 'alert');
    kasten.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:2147483000;' +
      'max-width:540px;margin:0 auto;padding:16px 18px;border-radius:14px;' +
      'background:#fff;color:#182f54;border:2px solid #d33a2c;' +
      'box-shadow:0 18px 44px rgba(0,0,0,.24);font:400 14px/1.55 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;';

    var titel = document.createElement('p');
    titel.textContent = t('wache_titel');
    titel.style.cssText = 'margin:0 0 6px;font-weight:700;font-size:15px;color:#b3261e;';

    var text = document.createElement('p');
    text.textContent = t('wache_text');
    text.style.cssText = 'margin:0 0 12px;';

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.textContent = t('wache_knopf');
    knopf.style.cssText = 'appearance:none;border:0;border-radius:10px;padding:10px 16px;' +
      'background:#182f54;color:#fff;font:600 14px/1 inherit;cursor:pointer;';
    knopf.addEventListener('click', function () {
      knopf.disabled = true;
      jsonAn(wurzelPfad() + 'cart/change.js', { id: zeile.key, quantity: 0 })
        .then(function () { window.location.reload(); })
        .catch(function () { knopf.disabled = false; });
    });

    kasten.appendChild(titel);
    kasten.appendChild(text);
    kasten.appendChild(knopf);
    document.body.appendChild(kasten);
  }

  function bannerVerstecken() {
    var k = document.getElementById(WACHE_ID);
    if (k && k.parentNode) k.parentNode.removeChild(k);
  }

  /* Klicks auf alles, was zur Kasse fuehrt, in der Auffangphase
     abfangen - so kommt kein Handler der Sections mehr dran.  */
  document.addEventListener('click', function (e) {
    if (!gesperrt) return;
    var ziel = e.target && e.target.closest
      ? e.target.closest('[name="checkout"], button[value="Checkout"], a[href*="/checkout"], .shopify-payment-button__button')
      : null;
    if (!ziel) return;
    e.preventDefault();
    e.stopPropagation();
    var k = document.getElementById(WACHE_ID);
    if (k) k.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);

  function wachePruefen() {
    fetch(wurzelPfad() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (warenkorb) {
        var kaputt = kaputteZeilen(warenkorb);
        if (!kaputt.length) {
          gesperrt = false;
          bannerVerstecken();
          return;
        }
        gesperrt = true;
        bannerZeigen(kaputt[0]);
      })
      .catch(function () { /* ohne Warenkorb-Antwort kein Urteil */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wachePruefen);
  } else {
    wachePruefen();
  }
  document.addEventListener('cart:build', function () { setTimeout(wachePruefen, 400); });
})();